import shop from "@/api/formulaMultipliers";

// initial state
const state = {
  all: [],
  formulaMultiplier: {}
};

// getters
const getters = {
  formulaMultiplier: state => {
    return state.formulaMultiplier;
  },
  formulaMultiplierCategories: state => {
    return state.all.map(m => {
      return {
        name: m.formulaMultiplierCategory
          ? m.formulaMultiplierCategory.name + " - " + m.name
          : m.name,
        id: m.id
      };
    });
  }
};

// actions
const actions = {
  getAllFormulaMultipliers: async context => {
    let d = (await shop.getFormulaMultipliers()).data;
    context.commit("getFormulaMultipliers", d);
  },
  searchFormulaMultiplier: async (context, formulaMultiplier) => {
    let d = (await shop.searchFormulaMultiplier(formulaMultiplier)).data;
    context.commit("getFormulaMultipliers", d);
    return d;
  },
  getFormulaMultiplier: async (context, id) => {
    let d = (await shop.getFormulaMultiplier(id)).data;
    context.commit("getFormulaMultiplier", d);
    return d;
  },
  postFormulaMultiplier: async (context, formulaMultiplier) => {
    const result = (await shop.postFormulaMultiplier(formulaMultiplier)).data;
    context.commit("postFormulaMultiplier", result);
  },
  putFormulaMultiplier: async (context, formulaMultiplier) => {
    const result = (await shop.putFormulaMultiplier(formulaMultiplier)).data;
    context.commit("putFormulaMultiplier", result);
  },
  deleteFormulaMultiplier: async (context, formulaMultiplier) => {
    (await shop.deleteFormulaMultiplier(formulaMultiplier)).data;
    context.commit("deleteFormulaMultiplier", formulaMultiplier);
  }
};

// mutations
const mutations = {
  getFormulaMultipliers(state, formulaMultipliers) {
    state.all = formulaMultipliers;
  },
  getFormulaMultiplier(state, formulaMultiplier) {
    //state.formulaMultiplier = formulaMultiplier
    state.formulaMultiplier = null;
    state.formulaMultiplier = Object.assign({}, state.formulaMultiplier, formulaMultiplier);
  },
  postFormulaMultiplier(state, formulaMultiplier) {
    //state.formulaMultiplier = formulaMultiplier
    state.formulaMultiplier = null;
    state.formulaMultiplier = Object.assign({}, state.formulaMultiplier, formulaMultiplier);
  },
  putFormulaMultiplier(state, formulaMultiplier) {
    //state.formulaMultiplier = formulaMultiplier
    state.formulaMultiplier = null;
    state.formulaMultiplier = Object.assign({}, state.formulaMultiplier, formulaMultiplier);
  },
  deleteFormulaMultiplier(state, formulaMultiplier) {
    state.all.splice(state.all.indexOf(formulaMultiplier), 1);
  },
  decrementFormulaMultiplierInventory(state, { id }) {
    const formulaMultiplier = state.all.find(formulaMultiplier => formulaMultiplier.id === id);
    formulaMultiplier.inventory--;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
